<!--p class="title p4-semibold text-uppercase text-muted gmx-8 gmt-20 gmb-8">
  {{ 'RESULTS.MENU.ADD.BLOOD' | translate }}
</p-->
<app-card-nav-item
  [title]="'RESULTS.MENU.ADD.BLOOD'"
  icon="gpicon-blood"
  class="gmb-8 button"
  url="/blood/manual-add-result"
  (clicked)="navItemClick()"
></app-card-nav-item>
<!-- TEMPORARY HIDDEN THIS FEATURE -> https://app.asana.com/0/1154881904776753/1201065212827568  -->
<!-- <app-card-nav-item
  [title]="'RESULTS.MENU.ADD.UPLOAD_BLOOD_REPORT'"
  icon="gpicon-camera"
  class="gmb-8 button"
  url="/blood/upload-report"
  (clicked)="navItemClick()"
></app-card-nav-item> -->

<!--p class="title p4-semibold text-uppercase text-muted gmx-8 gmt-20 gmb-8">
  {{ 'RESULTS.MENU.ADD.LIFESTYLE_INSIGHTS' | translate }}
</p-->
<app-card-nav-item
  [title]="'RESULTS.MENU.ADD.HABITS'"
  icon="gpicon-habits"
  class="gmb-8 button"
  url="/healthscore/questionnaire"
  (clicked)="navItemClick()"
></app-card-nav-item>
<app-card-nav-item
  [title]="'RESULTS.MENU.ADD.BODY'"
  icon="gpicon-body"
  class="gmb-8 button"
  url="/measurement/add-result"
  (clicked)="navItemClick()"
></app-card-nav-item>
